import React from 'react';
import SearchBar from './SearchBar';
import TimeRangeSelector from './TimeRangeSelector';
import MultiSelectDropdown from '../dropdown/MultiSelectDropdown';
import { useFilters } from '../../hooks/useFilters';

const FilterBar = ({
  searchProps,
  timeRangeProps,
  filterState, // Full filter state from App
  onFilterChange // Callback to update filters in App
}) => {
  const {
    makes = [],
    models = [],
    operators = [],
    selectedMakes = [],
    selectedModels = [],
    selectedOperators = [],
    filteredDeviceIds = [],
    loading = {},
    error
  } = filterState || {};

  return (
    <div className="filter-bar">
      <div className="filter-bar-left">
        <MultiSelectDropdown
          placeholder="Operator"
          options={operators}
          selected={selectedOperators}
          onChange={(newOperators) => onFilterChange('operators', newOperators)}
          disabled={loading.operators}
          entityName="Operators"
        />
        <MultiSelectDropdown
          placeholder="Make"
          options={makes}
          selected={selectedMakes}
          onChange={(newMakes) => onFilterChange('makes', newMakes)}
          disabled={loading.makes}
          entityName="Makes"
        />
        <MultiSelectDropdown
          placeholder="Model"
          options={models}
          selected={selectedModels}
          onChange={(newModels) => onFilterChange('models', newModels)}
          disabled={loading.models}
          entityName="Models"
        />
        <SearchBar
          {...searchProps}
          suggestions={filteredDeviceIds}
          loading={loading.devices}
        />
      </div>
      <div className="filter-bar-right">
        <TimeRangeSelector {...timeRangeProps} />
      </div>
    </div>
  );
};

export default FilterBar;
